import React from "react";
import AddFestival from "../components/AddFestival/AddFestival";

function AddFestivalPage() {
  return (
    <div className="AddFestivalPage">
      <AddFestival />
    </div>
  );
}

export default AddFestivalPage;
